import { useQuery } from '@tanstack/react-query'
import { cumulativeAssessmentAdminApi } from '@/api/cumulativeAssessmentAdmin'
import { coachingKeys } from './useCoachingToday'

// 누적 테스트 상세. 코칭 탭과 채점 탭이 같은 캐시를 쓰므로 탭을 오가면 받아 둔 상세가 바로 보인다.
// 세그먼트 상태는 원생 기기에서도 바뀌므로 화면에 들어올 때마다 다시 확인한다(staleTime 0).
export function useCumulativeAssessmentDetail(
  learnerId: number,
  assessmentId: number | null,
  { refetchOnWindowFocus = false }: { refetchOnWindowFocus?: boolean | 'always' } = {},
) {
  return useQuery({
    queryKey: coachingKeys.cumulativeAssessment(learnerId, assessmentId ?? 0),
    queryFn: () => cumulativeAssessmentAdminApi.getDetail(learnerId, assessmentId as number),
    enabled: assessmentId != null,
    staleTime: 0,
    refetchOnWindowFocus,
  })
}
